import React from "react";

export default function VideoPanel({ video }) {
  return (
  <div
    className="
      p-4 flex flex-col gap-4
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h3 className="text-lg font-semibold">Video</h3>

    {/* Selected video info */}
    <div className="text-sm text-gray-600 dark:text-gray-400">
      {video ? video.title || video.name || video.id : "No video selected"}
    </div>

    {/* Controls */}
    <div className="space-y-4 text-sm">
      {/* Trim start */}
      <label className="flex flex-col gap-1">
        <span className="text-gray-600 dark:text-gray-400">
          Trim start (s)
        </span>
        <input
          type="number"
          min={0}
          className="
            p-2 rounded-md
            bg-white dark:bg-gray-800
            border border-gray-300 dark:border-gray-700
            text-gray-900 dark:text-gray-100
            focus:outline-none focus:ring-2 focus:ring-blue-500
          "
        />
      </label>

      {/* Trim end */}
      <label className="flex flex-col gap-1">
        <span className="text-gray-600 dark:text-gray-400">
          Trim end (s)
        </span>
        <input
          type="number"
          min={0}
          className="
            p-2 rounded-md
            bg-white dark:bg-gray-800
            border border-gray-300 dark:border-gray-700
            text-gray-900 dark:text-gray-100
            focus:outline-none focus:ring-2 focus:ring-blue-500
          "
        />
      </label>

      {/* Brightness */}
      <label className="flex flex-col gap-1">
        <span className="text-gray-600 dark:text-gray-400">
          Brightness
        </span>
        <input
          type="range"
          min={0}
          max={2}
          step={0.01}
          className="w-full accent-blue-500"
        />
      </label>

      {/* Apply button */}
      <button
        className="
          mt-2 w-full py-2 rounded-lg
          bg-blue-600 hover:bg-blue-700
          text-white
          transition-colors
        "
      >
        Apply
      </button>
    </div>
  </div>
);

}